import React, { useEffect, useState } from "react";
import SplashScreen from "../SplashScreen/SplashScreen";
import Login from "../Login/Login";
import { getApiAction } from "../../Utils/helper";
import { useDispatch } from "react-redux";

const Home = () => {
  const [showSplashScreen, setShowSplashScreen] = useState(true);  
  const [staticData, setStaticData] = useState([]);  
  const dispatch = useDispatch();

  useEffect(() => {
    return async () => {
    let staticData = await getApiAction('auth/static-data', {}, 0, dispatch);
    setStaticData(staticData?.banners);
      
    const handleActivity = () => {
      // User activity detected, set showSplashScreen to false
      setShowSplashScreen(false);
      // Remove event listeners to prevent further checks
      // window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('click', handleActivity);
    };

    // Add event listeners for mousemove and click events
    // window.addEventListener('mousemove', handleActivity);
    window.addEventListener('click', handleActivity);

    // Cleanup: Remove event listeners when the component unmounts
    return () => {
      // window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('click', handleActivity);
    };
  }
  }, []); // Empty dependency array means this effect runs once when the component mounts


  return <div>{showSplashScreen ? <SplashScreen bannerData={staticData}/> : <Login />}</div>;
};

export default Home;
